export const metricCardToneMap = {
  blue: {
    bg: 'custom.surfaceAlt',
    color: 'info.main',
    border: 'info.main',
  },
  green: {
    bg: 'success.secondary',
    color: 'success.main',
    border: 'success.main',
  },
  red: {
    bg: 'error.secondary',
    color: 'error.main',
    border: 'error.main',
  },
  slate: {
    bg: 'custom.surfaceAlt',
    color: 'custom.background',
    border: 'custom.terminalTextLine',
  },
};

export const metricCardStyles = {
  root: (colors, interactive = false) => ({
    p: 2,
    height: 100,
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    borderColor: colors.border,
    borderRadius: 2,
    boxShadow: '0 8px 24px rgba(15, 23, 42, 0.04)',
    bgcolor: 'background.paper',
    width: '100%',
    textAlign: 'left',
    font: 'inherit',
    cursor: interactive ? 'pointer' : 'default',
    transition: 'border-color 160ms ease, background-color 160ms ease, transform 160ms ease',
    ...(interactive && {
      '&:hover': {
        bgcolor: 'custom.summaryHoverBg',
        borderColor: colors.color,
        transform: 'translateY(-1px)',
      },
      '&:focus-visible': {
        outline: '2px solid',
        outlineColor: colors.color,
        outlineOffset: 2,
      },
    }),
  }),
  iconWrap: (colors) => ({
    width: 44,
    height: 44,
    borderRadius: '50%',
    bgcolor: colors.bg,
    color: colors.color,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  }),
  content: {
    minWidth: 0,
  },
  value: (value, colors) => {
    const isLongValue = String(value).length > 10;

    return {
      fontWeight: 700,
      color: colors.color,
      lineHeight: 1.15,
      fontSize: isLongValue ? '0.95rem' : undefined,
      whiteSpace: isLongValue ? 'normal' : undefined,
      wordBreak: 'break-word',
    };
  },
};
